import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'validate/:email_code',///:password_code
    loadChildren: () =>
      import('./validate-account/validate-account.module').then((m) => m.ValidateAccountModule),
  },
  {
    path: 'forgot/:email_code/:password_code',
    loadChildren: () =>
      import('./validate-account/validate-account.module').then((m) => m.ValidateAccountModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
